import React from 'react'

type Props = {
    children?: React.ReactNode;
    expandedContent?: React.ReactNode;
    index?: number;
    isExpanded?: boolean;
}

const AlternatingTableRow = ({ children, index, isExpanded, expandedContent }: Props) => {
    function getBackgroundColor() {
        if (index != null && index % 2 === 0) {
            return 'bg-white';
        }
        return 'bg-utility-row';
    }
    return (
        <>
            <tr className={`${getBackgroundColor()} min-h-5`} >
                {children}
            </tr>
            {isExpanded && (
                <tr className={`${getBackgroundColor()}`} >
                    {expandedContent}
                </tr>
            )}
        </>
    )
}

export default AlternatingTableRow